import React from 'react';

import { oilAPI } from 'api/requests';

import Header from './Header';
import FormulaTypeSection from './FormulaTypeSection';
import NotesSection from './NotesSection';
import GeneralInformation from './GeneralInformation';
import ChangeStatus from './ChangeStatus';
import FilePicker from 'Components/FilePicker';
import ApplicationActions from 'Components/ApplicationActions';
import ContactDetails from './ContactDetails'
import DownloadSection from './DownloadSection'

export default class DetailsApplication extends React.Component {
  _handleBackClick = () => {
    const { user } = this.props;

    user.goBack();
  };

  render() {
    const { user, match, applicationData, getAvailableActionsListBasedOnStatusAndYear, updateApplicationData } =
      this.props;
    const { applicationId } = match.params;

    if (!applicationData) {
      return (
        <section className='scene__scene-wrapper'>
          <section className='scene__content-wrapper detailsScene__content-wrapper'>
            <Header user={user} loadInProgress={true} />
            <div className='ect-spinner _width_pc_100 _height_120'>
              <div className='ect-spinner__image' />
            </div>
          </section>
        </section>
      );
    } else {
      const {
        applicationStatus,
        isReadAcrossFormula,
        baseOilNumber,
        isPaid,
        notes,
        submissionDate,
        formulatorNumber,
        baseFormulaBaseOilNumber,
        engineType,
        testReports,
        description,
        approvalDate,
        submittedBy,
        manufacturerAddress,
      } = applicationData;

      const availableActions = getAvailableActionsListBasedOnStatusAndYear(
        applicationStatus,
        8000,
        applicationId,
        updateApplicationData,
        isPaid
      );

      return (
        <React.Fragment>
          <section className='scene__scene-wrapper'>
            <section
              className={`scene__content-wrapper detailsScene__content-wrapper ${applicationStatus.toLowerCase()}`}
            >
              <Header
                applicationStatus={applicationStatus}
                applicationId={applicationId}
                availableActions={availableActions}
                user={user}
                loadInProgress={!applicationData}
              />
              <FormulaTypeSection
                isReadAcrossFormula={isReadAcrossFormula}
                baseOilNumber={baseOilNumber}
                isPaid={isPaid}
              />
              <GeneralInformation
                submissionDate={submissionDate}
                approvalDate={approvalDate}
                formulatorNumber={formulatorNumber}
                baseFormulaBaseOilNumber={baseFormulaBaseOilNumber}
                engineType={engineType}
                isReadAcrossFormula={isReadAcrossFormula}
                description={description}
              />
              <NotesSection notes={notes} />
              <ContactDetails submittedBy={submittedBy} manufacturerAddress={manufacturerAddress} />
              {!!testReports.length && (
                <section className='scene_section'>
                  <FilePicker
                    isEditable={false}
                    files={testReports}
                    sectionHeaderClassName='_margin_top_0 _font_size_14'
                    httpParams={{
                      currentId: applicationId,
                      currentMethod: oilAPI.downloadReport,
                    }}
                  />
                </section>
              )}
              <ChangeStatus
                applicationId={applicationId}
                user={user}
                status={applicationStatus}
                availableActions={availableActions}
              />
              <DownloadSection
                user={user}
                applicationStatus={applicationStatus}
                applicationId={applicationId}
                name={baseOilNumber}
              />
              <ApplicationActions backButtonLabel='Back' backButtonAction={this._handleBackClick} />
            </section>
          </section>
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/Details/index.jsx